import React, { memo, ReactNode, useContext } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { SideNavContext } from './SideNav.context'

interface Props {
  label: string
  children: ReactNode
}

/**
 * One titled section of the rail, as in the dashboard's `SideMenu`: h6 title, items below, a
 * bottom rule. The padding is the same in both rail states so the items inside never shift; the
 * title fades and folds to zero height when the rail collapses rather than unmounting.
 */
const SideNavGroupComponent = ({ label, children }: Props) => {
  const { isCollapsed } = useContext(SideNavContext)

  return (
    <div
      role="group"
      aria-label={label}
      css={tw`border-0 border-b border-solid border-shades-200 px-3 pb-3 pt-3`}
    >
      <Typography
        variant="h6"
        aria-hidden={isCollapsed}
        css={[
          tw`overflow-hidden whitespace-nowrap px-2 text-shades-500 transition-[max-height,margin,opacity] duration-200 ease-in-out motion-reduce:transition-none`,
          isCollapsed ? tw`mb-0 max-h-0 opacity-0` : tw`mb-2 max-h-5 opacity-100`,
        ]}
      >
        {label}
      </Typography>
      {children}
    </div>
  )
}

export const SideNavGroup = memo(SideNavGroupComponent)
